import { createQuery, request } from '@luna/api';
import { isFeatureEnabled } from '@luna/gatekeeper';

import type { BankMessagesResponse } from './BankMessagesTypes';
import { BankMessageFlag } from './BankMessagesTypes';
import { getBankMessagesUrl } from './BankMessagesService';

export const [
    useUnreadBankMessages,
    {
        queryApi: queryUnreadBankMessages,
        selectData: selectUnreadBankMessagesData,
        invalidate: invalidateUnreadBankMessages,
    },
] = createQuery({
    name: 'bank-messages/unread-messages',
    condition: () => isFeatureEnabled((features) => features.bankMessages),
    payloadCreator: async () => {
        const response = await request<BankMessagesResponse>(
            `${getBankMessagesUrl()}?filterByUnread=true&filterByFlags=${BankMessageFlag.UNREAD}`,
        );

        return response.messages ?? [];
    },
});
